import { z } from 'zod';
import { SellLimitFieldNames } from '../../components/fieldNames';

export const rateSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal('exactRate'),
        [SellLimitFieldNames.EXACT_RATE_IDS_FIELD_NAME]: z.array(z.string()).nonempty(),
    }),
    z.object({
        type: z.literal('rateGroup'),
        [SellLimitFieldNames.RATE_GROUP_IDS_FIELD_NAME]: z.array(z.string()).nonempty(),
    }),
]);

export const allSpacesSchema = z.object({
    type: z.literal('allSpaces'),
});

export const resourceCategorySchema = z.object({
    type: z.literal('resourceCategory'),
    [SellLimitFieldNames.RESOURCE_CATEGORY_IDS_FIELD_NAME]: z.array(z.string()).nonempty(),
});
